module.exports = __webpack_public_path__ + "static/media/age-5.dd0bd7da.svg";